import React from 'react';
import ReactDOM from "react-dom";
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import get from 'lodash/get';
import AovProgressBarStore from 'stores/AovProgressBar/AovProgressBarStore';
import DiscountStore from 'stores/AovProgressBar/DiscountStore';
import pageStore from 'stores/AovProgressBar/PageStore';
import * as aovUtils from 'stores/AovProgressBar/Utils';
import * as shopwareCartUtils from "common/cart-utils/Shopware";
import * as constants from 'Constants';
import * as api from 'Api';
import * as utils from 'Utils';
import apiReady from './ready';
import 'styles/main.scss';


const AovProgressBar = loadable(() => import('containers/AovProgressBar'));


// Note:
// Can't use `utils.isProduction()` to check production mode. If you use that samples
// will always get included into assets for some unknown reasons.
let samples = {};
if (process.env.NODE_ENV !== 'production') {
  samples = require('./samples').default;
}


@observer
class App extends React.Component {
  constructor(props) {
    super(props);
    this.aov = new AovProgressBarStore();

    pageStore.reset();
    this.onCartUpdate = this.onCartUpdate.bind(this);
  }

  componentDidMount() {
    this.start();
  }

  componentWillUnmount() {
    document.removeEventListener('ov_cart_update', this.onCartUpdate, false);
  }

  start = async () => {
    if (!window.OnVoardAovProgressBar) window.OnVoardAovProgressBar = {};
    if (!window.OnVoardAovProgressBar['pageview_id']) window.OnVoardAovProgressBar['pageview_id'] = utils.uniqueId();

    await this.setupPreview();
    await this.loadAovProgressBar();
  };

  onCartUpdate = (evt) => {
    aovUtils.handleCartUpdate(evt.detail);
  };

  setupPreview = () => {
    if (!utils.isPreview()) return;
    if (!window.OV_PREVIEW_DATA) window.OV_PREVIEW_DATA = {};

    window.ovReloadPreview = async () => {
      const el = document.querySelector(".ov-app-aov-progress-bar");
      if (!el) return;

      await this.aov.deserialize(window.OV_PREVIEW_DATA.aov_progress_bar);
      await pageStore.deserialize(window.OV_PREVIEW_DATA.page);
      if (!pageStore.platform) pageStore.setPlatform(this.aov.platform);

      aovUtils.loadAovProgressBarCustomStyles(el, this.aov);
    };
  };

  embedInlineWidget = (aov, el) => {
    const component = <AovProgressBar aov={aov} appEl={el} />;
    ReactDOM.render(<div className="ov-wrapper">{component}</div>, el);
  };

  postLoadedTasks = () => {
    if (pageStore.allReady) {
      apiReady();
    }
  };

  loadAovProgressBar = async () => {
    const platform = utils.getEcommercePlatform();
    if (!pageStore.platform) pageStore.setPlatform(platform);

    const nodeList = document.querySelectorAll(".ov-app-aov-progress-bar");

    if (nodeList.length > 0) {
      utils.setupCartUpdateEvent();

      if (utils.isProduction()) {
        document.addEventListener('ov_cart_update', this.onCartUpdate, false);
      }

      if (pageStore.isShopware) {
        import('common/cart-utils/Shopware')
        .then((shopwareCartUtils) => {
          shopwareCartUtils.setupCheckoutOffCanvasEvent();
        });
      }

      utils.loadInitialCartData();
    }

    nodeList.forEach((el) => {
      const appId = el.getAttribute('data-app-id');
      if (!appId) return;

      const aov = new AovProgressBarStore();
      aov.setId(appId);
      aov.setEl(el);
      pageStore.addAov(aov);
    })

    const processEl = async (aov) => {
      let el = aov.el;

      if (!utils.isProduction()) {
        await aov.deserialize(samples.s1.aov_progress_bar);
        await pageStore.deserialize(samples.s1.page);

        this.postLoadedTasks();
        aovUtils.loadAovProgressBarCustomStyles(el, aov);
        this.embedInlineWidget(aov, el);
        return;
      }

      if (utils.isPreview()) {
        await aov.deserialize(window.OV_PREVIEW_DATA.aov_progress_bar);
        await pageStore.deserialize(window.OV_PREVIEW_DATA.page);
        aovUtils.updateLoadedCart(true);

        this.postLoadedTasks();
        aovUtils.loadAovProgressBarCustomStyles(el, aov);
        this.embedInlineWidget(aov, el);
        this.aov = aov;
        return;
      }

      const successCallback = async (response) => {
        await aov.deserialize(response);

        el = aovUtils.setupPlacement(el, aov);
        if (!el) return;

        this.postLoadedTasks();
        aovUtils.loadAovProgressBarCustomStyles(el, aov);
        this.embedInlineWidget(aov, el);

        if (pageStore.onReadyCallback) {
          try {
            pageStore.onReadyCallback();
          } catch (error) {
            console.error(error);
          }
        }
      };

      const errorCallback = (errors) => {
        utils.printErrors(errors);
      };

      const params = {};
      params['pageview_id'] = window.OnVoardAovProgressBar['pageview_id'];
      api.getAovProgressBarPayloads(successCallback, errorCallback, aov.id, params);
    };

    pageStore.aovList.forEach((aov) => {
      processEl(aov);
    })
  };

  render() {
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html: require('../static/icons/bp-icon.svg').default}} />
        <div dangerouslySetInnerHTML={{__html: require('../static/icons/fa-icon.svg').default}} />
      </div>
    )
  }
}



export default App;
